<template>
  <section class="app-ecommerce-details">
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="product === undefined">
      <h4 class="alert-heading">
        {{ $t('trip.shop.alert.fetching_data_product') }}
      </h4>
      <div class="alert-body">
        {{ $t('trip.shop.alert.no_items') }}
      </div>
    </b-alert>
    <!--      Content-->
    <b-overlay v-if="productLoaded && product" spinner-medium>
      <b-card v-if="productLoaded && product" no-body>
        <b-card-body>
          <b-row class="my-2">
            <!-- Left: Product Image Container -->
            <b-col cols="4" style="max-height: 400px"> <!--  class="d-flex align-items-center justify-content-center mb-2 mb-md-0" -->
              <div v-if="!product.mainVariant" class="h-100 d-flex align-items-center justify-content-center">
                <div class="product-img h-100">
                  <b-img
                    :src="require('@/assets/images/logo/logo.png')"
                    fluid
                  />
                </div>
              </div>
              <div v-if="product.mainVariant && product.mainVariant && product.mainVariant.files && product.mainVariant.files.length < 2" class="h-100 d-flex align-items-center justify-content-center">
                <div class="product-img h-100">
                  <b-img
                    :src="resolveProductImgScrc(product)"
                    fluid
                  />
                </div>
              </div>
              <div v-else-if="product.mainVariant && product.mainVariant && product.mainVariant.files && product.mainVariant.files.length > 1" class="h-100 d-flex align-items-center justify-content-center">
                <swiper class="swiper-wrapper h-100" :options="swiperOptions" :modules="modules" navigation :pagination="{ clickable: true }">
                  <swiper-slide v-for="file in product.mainVariant.files" :key="file.id" class="swiper-slide h-100">
                    <div class="product-img h-100">
                      <b-img
                        :src="file.fileUrls[300]"
                        fluid
                      />
                    </div>
                  </swiper-slide>
                </swiper>
                <div class="swiper-button-next" slot="button-next"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>

              </div>
            </b-col>
            <!-- Right: Product Details -->
            <b-col cols="7">
              <!-- Product Name -->
              <div>
                <h4 v-if="product.name" class="mb-0 mr-1">
                  <b-link class="font-weight-bold">
                    {{ product.name | trans }}
                  </b-link>
                </h4>
                <b-card-text v-if="product.mainCategory.name" class="mb-0">
                  <span>{{ product.mainCategory.name | trans }}</span>
                </b-card-text>
                <!-- Product Brand -->
                <b-card-text class="item-company my-0">
                  <span>{{ $t('common.by') }}</span>
                  <b-link
                    class="company-name"
                    :to="{
                      name: 'provider-details',
                      params: {
                        provider_id: product.organization.id,
                        trip_id: $route.params.trip_id,
                        step_id: $route.params.step_id,
                        event_id: $route.params.event_id,
                        airport_id: $route.params.airport_id,
                      },
                    }"
                  >
                    {{ product.organization.legalName ? product.organization.legalName : product.organization.commercialName }}
                  </b-link>
                </b-card-text>
                <div v-if="product.mainVariant && product.mainVariant.packing && (product.mainVariant.prices.length > 0 || product.mainVariant.rangePrices.length > 0)" class="mt-1">
                  <p class="pb-0 mb-0"> {{ $t('service.prices.type') }} : {{ product.mainVariant.pricingType | enumTranslate('pricing_type') }}</p>
                  <p class="pb-0 mb-0"> {{ $t('service.prices.type_measurement') }} : {{ product.mainVariant.packing.name | trans }}</p>
                </div>
                <div v-if="product.minPrice && (!product.mainVariant.onQuote || product.className === 'PackageProduct')">
                  <p v-if="product.mainVariant.discount" class="pb-0 mb-0">{{ $t('pricing.discount_rate') }} : {{ product.mainVariant.discount | percentFormat }}</p>
                  <p class="pb-0 mb-0">{{ $t('pricing.unit_price_before_tax') }} : {{ product.minPrice.displayPriceExcludingTaxes | priceFormat }}</p>
                  <p v-if="product.className === 'CoreProduct'" class="pb-0 mb-0">{{ $tc('pricing.ecotax', 1) }} : {{ product.minPrice.ecologicalTax | priceFormat }}</p>
                  <p class="pb-0 mb-0">{{ $t('pricing.unit_price_including_tax') }} : {{ (product.minPrice.displayPriceIncludingTaxes + product.minPrice.ecologicalTax) | priceFormat }}</p>
                </div>
              </div>

              <!-- Price And Ratings -->
              <div class="ecommerce-details-price d-flex flex-wrap mt-1">
                <h4 v-if="!product.minPrice || (product.mainVariant.onQuote && product.className !== 'PackageProduct')" class="item-price mr-1 mb-1">
                  {{ $t('trip.shop.price_on_quote') }}
                </h4>
              </div>

              <!-- Services inside package -->
              <!-- package_cart_line -->
              <div
                v-if="(product.className === 'PackageProduct') && product.mainVariant.variants"
                class="mt-1"
              >
                <b-card-title v-if="product.mainVariant && product.mainVariant.description" class="mt-1">
                  {{ $tc('service.package.services') }}:
                </b-card-title>
                <ul v-for="variant in product.mainVariant.variants" :key="variant.id">
                  <li v-if="!variant.onQuote && variant.minPrice.displayPriceExcludingTaxes">
                    <span class="text-nowrap">
                      {{
                        variant.productName | trans
                      }} : {{
                        variant.minPrice.displayPriceExcludingTaxes * variant.packageQuantity | priceFormat
                      }} {{ $tc('pricing.before_tax', 0) }} ({{
                        variant.vatRate | percentFormat
                      }} {{ $t('pricing.vat_rate') }})
                    </span>
                  </li>
                  <li v-else>
                    <span v-if="variant.productName" class="text-nowrap">
                      {{ variant.productName | trans }} : {{ $t('trip.shop.price_on_quote') }}
                    </span>
                  </li>
                </ul>
              </div>

              <!-- TODO VHTML check if ok -->
              <b-card-title v-if="product.mainVariant && product.mainVariant.description" class="mt-1">
                {{ $tc('common.description') }}:
              </b-card-title>
              <b-card-text v-if="product.mainVariant && product.mainVariant.description">
                <div v-html="product.mainVariant.description[userLang]" />
              </b-card-text>
              <hr />
              <b-card-title v-if="product.mainVariant && product.mainVariant.variantAttributes.length">
                {{ $tc('service.additional_informations.characteristic', product.mainVariant.variantAttributes.length) }}
                :
              </b-card-title>
              <div v-if="product.mainVariant && product.mainVariant.variantAttributes.length">
                <div v-for="attribute in product.mainVariant.variantAttributes" :key="attribute.id">
                  <p v-if="attribute.inputValues">{{ attribute.attribute.name | trans }} : {{ attribute.inputValues | trans }}</p>
                  <p v-if="attribute.selectValue">
                    <b-link :href="attribute.selectValue.iconFileUrl" target="_blank">
                      <img v-if="attribute.selectValue.iconFileUrl" height="25px" width="25px" :src="attribute.selectValue.iconFileUrl" :alt="attribute.selectValue.name">
                    </b-link>
                    {{ attribute.attribute.name | trans }} : {{ attribute.selectValue.name | trans }}
                  </p>
                  <div v-if="attribute.choiceValues">
                    <p v-for="choice in attribute.choiceValues">
                      <b-link :href="choice.iconFileUrl" target="_blank">
                        <img v-if="choice.iconFileUrl" height="25px" width="25px" :src="choice.iconFileUrl" :alt="choice.name">
                      </b-link>
                      {{ choice.name | trans }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-end justify-content-end flex-column">
                <div class="d-flex flex-column flex-sm-row pt-1">
                  <b-button
                    v-if="selected"
                    v-ripple.400
                    class="btn-cart"
                    :to="{
                      name: 'shop-checkout',
                      params: {
                        trip_id: $route.params.trip_id,
                        step_id: $route.params.step_id,
                        event_id: $route.params.event_id,
                        airport_id: $route.params.airport_id,
                      },
                    }"
                  >
                    <feather-icon icon="ShoppingCartIcon" class="mr-50" />
                    <span>
                      <span>{{ $t('trip.shop.action.view_in_cart') }}</span>
                    </span>
                  </b-button>
                  <b-button v-else v-ripple.400 class="btn-cart" @click="patchCart(product)">
                    <feather-icon icon="ShoppingCartIcon" class="mr-50" />
                    <span>
                      <span v-if="product.typology !== 'helicopter'">{{ $t('trip.shop.add_to_cart') }}</span>
                      <span v-else>{{ product.selected ? $t('trip.shop.book_flight') : $t('trip.shop.helicopter.action.select') }}</span>
                    </span>
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
        <hr />

        <!-- TODO: Delete it ? -->
        <transfer-availability v-if="false" />
        <shop-product-details-related-product v-if="product.className === 'CoreProduct'" :related-products="relatedProducts" />
      </b-card>
    </b-overlay>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { Navigation, Pagination } from 'swiper'
import { fetchOrganizationProductRequest } from '@/request/globalApi/requests/apiRequests'
import Cart from '@/models/Cart'
import transferAvailability from './transfer/transferAvailability.vue'
import ShopProductDetailsRelatedProduct from './ShopDetailsRelatedProduct.vue'
import 'swiper/css/swiper.min.css'
import 'swiper/components/navigation/navigation.scss'
import 'swiper/components/pagination/pagination.scss'

export default {
  name: 'ShopDetails',
  components: {
    transferAvailability,
    ShopProductDetailsRelatedProduct,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      productLoaded: false,
      product: null,
      productQuantity: 1,
      relatedProducts: null,
      cart: new Cart(),
      selected: false,
      swiperOptions: {
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  computed: {
    userLang() {
      return this.$store.state.appConfig.lang
    },
  },
  watch: {
    $route() {
      this.APIFetchProduct()
    },
  },
  mounted() {
    this.APIFetchProduct()
  },
  methods: {
    APIFetchProduct() {
      this.productLoaded = false
      const productId = this.$route.params.product_id
      const organizationId = this.$route.params.provider_id
      const tripStepId = this.$route.params.event_id
      fetchOrganizationProductRequest(tripStepId, organizationId, productId)
        .then(r => {
          const { product, selected } = r.data
          this.product = product
          this.selected = selected
        })
        .catch(() => {
          this.product = undefined
        })
        .finally(() => {
          this.productLoaded = true
        })
    },
    patchCart(product) {
      const tripStepId = this.$route.params.event_id

      if (product.className === 'PackageProduct') {
        this.cart.patchMandatoryPackage(tripStepId, product.mainVariant.id).then(() => {
          this.selected = true
        })
      } else {
        this.cart.patch(tripStepId, product.mainVariant.id, 1).then(() => {
          this.selected = true
        })
      }
    },
    showVariant(variant) {
      return !!(!variant?.onQuote && variant?.productName && variant?.minPrice?.displayPriceExcludingTaxes?.toString() && variant?.vatRate?.toString())
    },
    resolveProductImgScrc(product) {
      if (product?.mainVariant?.files?.length) return product.mainVariant.files[0]?.fileUrls[300]
      if (product?.mainCategory?.iconFileUrl) return product.mainCategory.iconFileUrl
      return require('@/assets/images/logo/logo.png')
    },
  },
  setup() {
    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }

    return {
      swiperOptions,
      modules: [Navigation, Pagination],
    }
  },
}
</script>

<style lang="scss" scoped>
.swiper-slide {
  width: 100%;
  height: 400px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 35.2px;
  background-color: var(--theme-banner);
  color: var(--text-secondary);
}
</style>

<style lang="scss">
@import '~@core/scss/base/pages/app-ecommerce-details.scss';
.badge-price {
  position: absolute;
  right: 8px;
  top: -24px;
}
</style>
